<template>
  <div
    class="projects-gallery-modal modal fade"
    :class="{'in show': open }"
    @click="onModalClick"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="$emit('update:open', false)"
          />
        </div>
        <div class="modal-body">
          <div class="projects-gallery-modal__left">
            <img
              :src="activeImage"
              alt="Active Image"
            >
            <div
              ref="splide"
              class="projects-gallery-modal__left__slider splide splide__dark"
            >
              <div class="splide__track">
                <div class="splide__list">
                  <div
                    v-for="image in slide.modalContent.modalImages"
                    :key="image"
                    class="splide__slide"
                  >
                    <img
                      :src="image"
                      alt=""
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="projects-gallery-modal__right">
            <h4 class="kicker">
              {{ slide.modalContent.modalKicker }}
            </h4>
            <h2 class="title">
              {{ slide.modalContent.modalTitle }}
            </h2>
            <div class="description">
              {{ slide.modalContent.modalDescription }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

export default {
  name: 'ProjectsGalleryModal',
  props: {
    slide: {
      type: Object,
      default: () => ({}),
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open'],
  data() {
    return {
      activeImage: null,
    };
  },
  watch: {
    slide(newVal) {
      if (newVal) {
        [this.activeImage] = newVal.modalContent.modalImages;
      }
    },
  },
  mounted() {
    [this.activeImage] = this.slide.modalContent.modalImages;
    this.initSlider();
  },
  methods: {
    changeActiveImage(splideIndex) {
      const index = splideIndex % this.slide.modalContent.modalImages.length;
      this.activeImage = this.slide.modalContent.modalImages[index];
    },
    initSlider() {
      const splideElement = this.$refs.splide;
      if (!splideElement) return;

      const slideCount = this.slide.modalContent.modalImages.length;

      // Don't initialize if no slides
      if (slideCount === 0) return;

      const options = {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        pagination: true,
        gap: 16,
        arrows: false,
        autoplay: true,
        interval: 6000,
        breakpoints: {
          768: {
            perPage: 2,
          },
        },
      };

      this.mainSplide = new Splide(splideElement, options);
      setupSplide(this.mainSplide);
      this.mainSplide.mount();
      this.mainSplide.on('move', (index) => {
        this.changeActiveImage(index);
      });
      this.mainSplide.on('click', ({index}) => {
        this.changeActiveImage(index);
      });
    },
    onModalClick(event) {
      if (event.target.classList.contains('projects-gallery-modal')) {
        this.$emit('update:open', false);
      }
    },
  },
};
</script>
